import React from "react";
import PropTypes from "prop-types";
import { IonAlert } from "@ionic/react";
import { Browser } from "@capacitor/browser";
import { isPlatform } from "@ionic/react";

export const openAppStore = async () => {
  const url = isPlatform("android")
    ? "https://play.google.com/store/apps/details?id=chalo.bharatdekhen.app"
    : "https://apps.apple.com/in/app/bharat-dekhen/id6478861610";

    if (isPlatform("android") || isPlatform("ios")) {
      await Browser.open({ url });
  }
};

const UpdateAvailableAlert = ({ showAlert }) => {
  return (
    <IonAlert
      isOpen={showAlert}
      header="Update Available"
      subHeader="A new update is available!"
      message="Please update the app to get the latest features and improvements."
      buttons={[
        {
          text: "OK",
          handler: openAppStore,
        },
      ]}
    />
  );
};

UpdateAvailableAlert.propTypes = {
  showAlert: PropTypes.bool.isRequired,
};

export default UpdateAvailableAlert;
